/**
 * Shared shadcn control chrome. Import these from primitives so focus, popup,
 * and menu-item styles stay one recipe after `npx shadcn add`.
 */
export const controlFocus =
  'tw:outline-none tw:focus-visible:border-ring tw:focus-visible:shadow-[0_0_0_3px_color-mix(in_oklab,var(--ring)_50%,transparent)]';

export const popupSurface =
  'tw:rounded-lg tw:border tw:border-border tw:bg-popover tw:text-popover-foreground tw:shadow-lg';

export const menuItem =
  'tw:relative tw:flex tw:h-8 tw:cursor-default tw:items-center tw:gap-2 tw:rounded-md tw:px-2 tw:text-sm tw:outline-hidden tw:select-none tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg]:shrink-0 tw:[&_svg:not([class*=size-])]:size-4';
